import { Link } from 'react-router-dom';
import { CircleUserRound, LogOut } from 'lucide-react';
import ViewUserAvatar from './ViewUserAvatar';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/app/ui/dropdown-menu';
import { useLogout } from '@/app/authentication/_hooks';

import { useSelf } from '@/data/user';

const UserAvatar = () => {
  const self = useSelf(false);
  const logout = useLogout();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="user-avatar-trigger">
        <ViewUserAvatar user={self.data} fallbackTestId="user-avatar-fallback" tooltip={false} />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>
          <p>
            {self.data.firstname} {self.data.lastname}
          </p>
          <span className="uppercase text-xs text-muted-foreground">
            {self.data.roles?.[0] || ''}
            {self.data.roles?.[1] && `, ${self.data.roles[1]}`}
          </span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild data-testid="user-avatar-my-account">
          <Link to="/profile">
            <CircleUserRound />
            My Account
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} data-testid="user-avatar-sign-out">
          <LogOut />
          Sign Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserAvatar;
